import { render, staticRenderFns } from "./base.modal.vue?vue&type=template&id=13b8f99c&scoped=true&"
import script from "./base.modal.vue?vue&type=script&lang=js&"
export * from "./base.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8f99c",
  null
  
)

export default component.exports